<h1 class="text-2xl md:text-3xl font-bold text-gray-900">Welcome back</h1>
<p class="text-gray-500 mt-1 mb-8">Sign in to continue to your workspace.</p>

<div *ngIf="(authSvc.user$ | async) as user; else login">
  <div class="rounded-control border border-gray-200 p-4 flex items-center gap-3 mb-4">
    <img *ngIf="user.photoURL" [src]="user.photoURL" [alt]="user.displayName" class="w-10 h-10 rounded-full">
    <div class="text-left">
      <div class="font-semibold text-gray-900">{{user.displayName}}</div>
      <div class="text-sm text-gray-500">{{user.email}}</div>
    </div>
  </div>
  <button class="btn btn-primary w-full mb-3" (click)="continue()">Continue as {{user.displayName}}</button>
  <button class="basic-link w-full text-center text-sm" (click)="authSvc.logout()">
    Log in with a different account
  </button>
</div>

<ng-template #login>
  <form [formGroup]="loginForm">
    <div class="dm-input">
      <label>Email address</label>
      <input formControlName="email" type="text" placeholder="you@company.com">
      <small class="red" *ngIf="email.touched && email.invalid">Must be a valid email</small>
    </div>
    <div class="dm-input relative">
      <label class="flex items-center justify-between">
        <span>Password</span>
        <a class="text-sm text-primary-700 hover:text-primary-700 font-medium" routerLink="../reset-password">Forgot password?</a>
      </label>
      <input formControlName="password" type="password" placeholder="••••••••">
      <small class="red" *ngIf="password.touched && password.invalid">Cannot be empty</small>
    </div>

    <button (click)="onLogin()" *ngIf="!processing" class="btn btn-primary w-full" type="button">Sign in</button>
    <button disabled class="btn btn-processing w-full" type="button" *ngIf="processing">
      <i class="fas fa-circle-notch"></i>
      Please wait...
    </button>

    <app-warning-message type="error" title="Sign in failed" message="Wrong email or password."
                          *ngIf="authSvc.invalidEmail || authSvc.wrongCredentials || authSvc.userNotFound"></app-warning-message>
    <app-warning-message type="error" title="Too many attempts" message="We have detected too many failed attempts. Wait a few minutes and try again."
                          *ngIf="authSvc.tooManyRequests"></app-warning-message>
    <app-warning-message type="error" title="Something went wrong" [message]="authSvc.unknownError"
                          *ngIf="authSvc.unknownError"></app-warning-message>
  </form>

  <div class="divider-new version-2 my-6 text-gray-500 flex items-center justify-center flex-row">
    <h6 class="small mx-2">OR</h6>
  </div>

  <div class="flex flex-col gap-3">
    <app-social-signin-button provider="google" label="Sign in with Google" (clicked)="authSvc.loginWithSocial('google.com')"></app-social-signin-button>
    <app-social-signin-button provider="microsoft" label="Sign in with Microsoft" (clicked)="authSvc.loginWithSocial('microsoft.com')"></app-social-signin-button>
  </div>

  <p class="text-sm text-gray-500 mt-8 text-center">
    <span class="mr-1">Don't have an account?</span>
    <a class="basic-link font-medium" routerLink="../signup">Create free account</a>
  </p>
</ng-template>
